import { render, staticRenderFns } from "./TaskMentionActivity.vue?vue&type=template&id=4e1b48ee"
import script from "./TaskMentionActivity.vue?vue&type=script&lang=js"
export * from "./TaskMentionActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports